<!--新增行号-->
<template>
  <e-dialog
    :dialog-title="'审核拒绝'"
    :center-dialog-visible="visible"
    :popup-width="'800px'"
    :button-tip="'审核拒绝'"
    :cancel-button-tip="'关 闭'"
    @resetPopupData="handleCancel"
    @submitPopupData="handleConfirm"
  >
    <div class="role_apply">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="70px"
        label-position="left"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请人:" class="el-form-item-first">
              {{ formData.applyList.createByName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请账号:" class="el-form-item-first">
              {{ formData.applyList.memberName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="申请角色:">
              <div
                v-if="formData.applyList.roleList?.length > 1"
                class="role_apply_content"
              >
                共计
                <span>{{ formData.applyList.roleList?.length }}</span> 个角色
                <span @click="viewRole(formData.applyList.roleList)"
                  >查看明细</span
                >
              </div>
              <div v-else class="role_apply_content">
                <span>{{ formData.applyList.roleList[0]?.roleName }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="拒绝原因:"
              prop="opinion"
              class="el-form-item-end"
            >
              <el-input
                v-model="formData.opinion"
                class="text-area"
                type="textarea"
                maxlength="100"
                show-word-limit
                placeholder="请输入拒绝原因"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <ViewDialog
      :table-list="tableList"
      :visible="viewRoleDialogShow"
      @close="closeCheckRole"
    ></ViewDialog>
  </e-dialog>
</template>

<script>
import EDialog from '@/components/common/e-dialog.vue';
import ViewDialog from './viewRoleDialog.vue';
import Api from '../../../api/authority';

export default {
  name: 'RoleApplyDialog',
  components: {
    EDialog,
    ViewDialog,
  },
  data() {
    return {
      loading: false,
      visible: false,
      formData: {
        opinion: '',
        applyList: {
          roleList: [],
        },
      },
      rules: {
        opinion: [
          {
            required: true,
            message: '请输入拒绝原因',
            trigger: 'blur',
          },
        ],
      },
      tableList: [],
      viewRoleDialogShow: false,
    };
  },
  created() {},

  mounted() {},

  methods: {
    viewRole(roleList) {
      this.queryByRoleIdList(roleList);
    },
    queryByRoleIdList(roleList) {
      const params = {
        roleIdList: roleList.map((item) => item.roleId),
      };
      Api.queryByRoleIdList(params).then((res) => {
        if (res.code === '200') {
          this.tableList = res.data;
          this.viewRoleDialogShow = true;
        }
      });
    },
    closeCheckRole() {
      this.viewRoleDialogShow = false;
    },
    initData(row) {
      this.visible = true;
      this.loading = false;
      this.formData.applyList = row;
    },
    handleCancel() {
      this.visible = false;
      this.formData = {
        opinion: '',
        applyList: {
          roleList: [],
        },
      };
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            applyId: this.formData.applyList.applyId,
            opinion: this.formData.opinion,
          };
          Api.roleRefuse(params).then((res) => {
            if (res.code === '200') {
              this.visible = false;
              this.$message.success('审批拒绝');
              this.$emit('getList');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.role_apply {
  :deep(.el-form-item) {
    margin-bottom: 10px;
    white-space: nowrap;
  }
  .el-form-item-first {
    margin-bottom: 0;
  }
  .el-form-item-end {
    :deep(.el-form-item__label) {
      margin-top: -10px;
      margin-left: -10px;
    }
  }
  .role_apply_content {
    span:nth-child(1) {
      margin: 0 3px;
    }
    span:nth-child(2) {
      color: #2587ff;
      font-size: 13px;
      cursor: pointer;
      margin-left: 3px;
    }
  }
}
</style>
